// eslint-disable-next-line no-restricted-imports -- Temporary import until core is merged into the hendrx app.
import { clientModules } from '@hendrx/hendrx/clientModules';
import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { getUploadSecureInfo } from 'shared/queries/fileUploadApi';
import { useUser } from 'shared/queries/user';
import { showErrorNotification } from 'shared/utils/notifications';

type File = Blob;

type UseFileUploadProps = {
  errorMessage?: string;
  fileName?: string;
};

export const useFileUpload = (props?: UseFileUploadProps) => {
  const { t } = useTranslation('utils.notification');
  const { user } = useUser();

  return useMutation({
    mutationFn: async (file: File): Promise<string | undefined> => {
      const uploadFileHandler = clientModules.fileStorage.uploadFile;
      return await uploadFileHandler(file, getUploadSecureInfo, user?.role, props?.fileName);
    },
    onError() {
      if (!props) return;
      const { errorMessage } = props;

      if (!errorMessage) return;
      showErrorNotification(errorMessage, t('error'));
    }
  });
};
